import { useWorker } from '@koale/useworker';
import DownloadIcon from '@mui/icons-material/Download';
import { Typography } from '@mui/material';
import { PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { Button, SplitButton } from '../../../components';
import {
  useDispatch,
  useSelector,
  salesListSlice,
  fetchSalesExportExcel,
  fetchSalesExportCommissionsHtml,
  fetchSalesExportSalesHtml,
} from '../../../stores';
import { handleMoney } from '../../../utils/Helpers';
import useResponsiveMode from '../../../utils/useResponsiveMode';
import { StyledTableHeader } from '../styles';
import {
  exportSalesToCSV,
  exportSalesCommissionsToHTML,
  exportSalesToHTML,
  handleApiDataSalesToCSV,
  handleApiDataSalesCommissionsToHTMLPartOne,
  handleApiDataSalesCommissionsToHTMLPartTwo,
  handleApiDataSalesCommissionsToHTMLPartThree,
  handleApiDataSalesToHTMLPartOne,
  handleApiDataSalesToHTMLPartTwo,
  handleApiDataSalesToHTMLPartThree,
  handleApiDataSalesToHTMLPartFour,
} from './exports';

export const VehiclesEntryTableToolbar = () => {
  const dispatch = useDispatch();
  const {
    salesList,
    salesExportExcelLoading,
    salesExportCommissionsHtmlLoading,
    salesExportSalesHtmlLoading,
    salesExportOperationalHtmlLoading,
  } = useSelector((state) => state.salesListReducer);
  const salesFiltersValues = useSelector(
    (state) => state.salesFiltersValuesReducer,
  );
  const { profileId } = useSelector((state) => state.authReducer);
  const responsiveMode = useResponsiveMode();
  const [exportSalesToCSVWorker] = useWorker(handleApiDataSalesToCSV);
  const [exportSalesCommissionsToHTMLPartOneWorker] = useWorker(
    handleApiDataSalesCommissionsToHTMLPartOne,
  );
  const [exportSalesCommissionsToHTMLPartTwoWorker] = useWorker(
    handleApiDataSalesCommissionsToHTMLPartTwo as any,
  );
  const [exportSalesCommissionsToHTMLPartThreeWorker] = useWorker(
    handleApiDataSalesCommissionsToHTMLPartThree,
  );
  const [exportSalesToHTMLPartOneWorker] = useWorker(
    handleApiDataSalesToHTMLPartOne,
  );
  const [exportSalesToHTMLPartTwoWorker] = useWorker(
    handleApiDataSalesToHTMLPartTwo,
  );
  const [exportSalesToHTMLPartThreeWorker] = useWorker(
    handleApiDataSalesToHTMLPartThree,
  );
  const [exportSalesToHTMLPartFourWorker] = useWorker(
    handleApiDataSalesToHTMLPartFour,
  );

  const handleExportExcel = () => {
    dispatch(fetchSalesExportExcel(salesFiltersValues)).then(
      (res: PayloadAction<any>) => {
        if (res.payload.data) {
          exportSalesToCSV(
            res.payload.data,
            res.payload.filters,
            dispatch,
            exportSalesToCSVWorker,
          ).then(() => {
            dispatch(salesListSlice.actions.toggleExportModalIsOpen());
          });
        } else dispatch(salesListSlice.actions.toggleExportModalIsOpen());
      },
    );
  };

  const handleExportCommissionsHtml = () => {
    dispatch(fetchSalesExportCommissionsHtml(salesFiltersValues)).then(
      (res: PayloadAction<any>) => {
        if (res.payload.data) {
          exportSalesCommissionsToHTML(
            res.payload.data,
            res.payload.startDate,
            res.payload.finalDate,
            dispatch,
            exportSalesCommissionsToHTMLPartOneWorker,
            exportSalesCommissionsToHTMLPartTwoWorker,
            exportSalesCommissionsToHTMLPartThreeWorker,
          ).then(() => {
            dispatch(salesListSlice.actions.toggleExportModalIsOpen());
          });
        } else dispatch(salesListSlice.actions.toggleExportModalIsOpen());
      },
    );
  };

  const handleExportSalesHtml = () => {
    dispatch(fetchSalesExportSalesHtml(salesFiltersValues)).then(
      (res: PayloadAction<any>) => {
        if (res.payload.data) {
          exportSalesToHTML(
            res.payload.data,
            res.payload.filters.users,
            res.payload.filters.areas,
            res.payload.filters.routes,
            dispatch,
            exportSalesToHTMLPartOneWorker,
            exportSalesToHTMLPartTwoWorker,
            //@ts-ignore
            exportSalesToHTMLPartThreeWorker,
            exportSalesToHTMLPartFourWorker,
          ).then(() => {
            dispatch(salesListSlice.actions.toggleExportModalIsOpen());
          });
        } else dispatch(salesListSlice.actions.toggleExportModalIsOpen());
      },
    );
  };

  const handleExportOperationalHtml = () => {
    dispatch(salesListSlice.actions.toggleSalesOperationalExportIsOpen());
  };

  return (
    <StyledTableHeader>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginTop: 10,
        }}
      >
        {responsiveMode !== 'phone' && (
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            {profileId !== 9 && (
              <>
                <Button
                  variant='contained'
                  label='Exportar em excel'
                  startIcon={<DownloadIcon />}
                  onClick={() => handleExportExcel()}
                  loading={salesExportExcelLoading}
                />
                <SplitButton
                  label='Exportar em HTML'
                  startIcon={<DownloadIcon />}
                  loading={
                    salesExportCommissionsHtmlLoading ||
                    salesExportSalesHtmlLoading ||
                    salesExportOperationalHtmlLoading
                  }
                  options={[
                    {
                      label: 'Relatório de comissões (declaração)',
                      onClick: handleExportCommissionsHtml,
                    },
                    {
                      label: 'Relatório de vendas resumidas',
                      onClick: handleExportSalesHtml,
                    },
                    // {
                    //   label: 'Relatório de apoio operacional',
                    //   onClick: handleExportOperationalHtml,
                    // },
                  ]}
                />
              </>
            )}
          </div>
        )}
        <Typography margin={1} sx={{ textAlign: 'right', paddingRight: 2 }}>
          Qtd.: {salesList?.size}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Total:{' '}
          {handleMoney(salesList?.totalAmount)}
        </Typography>
      </div>
    </StyledTableHeader>
  );
};
